<div
    class="detail--wrapper supplier--detail-wrapper"
    id="supplierDetailWrapper"
    [ngClass]="supplierService.method == 'NEW' || (supplierService.method == 'EDIT' && !showPassDiv) ? 'edit--mode' : ''"
    data-testid="t-detail-div-1752672977568-36"
>
    <app-title-bar
        [title]="'mws.supplier' | i18n"
        [subtitle]="'mws.detailview' | i18n"
        [extra]="supplierName"
        [searchBar]="false"
        [buttons]="titleButtons"
        (buttonClick)="cardButtonClick($event)"
        data-testid="t-detail-app-title-bar-1752672977568-1"
    ></app-title-bar>

    <!--    <div class="fixed&#45;&#45;pass-toggler"-->
    <!--         *ngIf="supplierService.method === 'NEW' || (supplierService.method === 'EDIT' && !showPassDiv)">-->
    <!--        <button (click)="showPass();" *ngIf="showPassButton" class="btn btn-success btn-lg" type="button">-->
    <!--            <i class="oc-search"></i>-->
    <!--        </button>-->
    <!--    </div>-->

    <div
        class="fixed--mini-pass"
        data-testid="t-detail-div-1752672977568-1"
    >
        <!--        [imagePath]="'/mws/rest/supplierIcon?language=' + environmentService.appSettings.locale + '&imageId='"-->
        <app-overview-card
            [imgId]="supplierService.supplierBasedata && supplierService.supplierBasedata.imageId ? supplierService.supplierBasedata.imageId : null"
            [imagePath]="imagePath"
            [showRating]="false"
            [rating]="0"
            [title]="supplierName"
            [cardDescriptions]="supplierCarddescription"
            data-testid="t-detail-app-overview-card-1752672977568-1"
        ></app-overview-card>
        <!--        [states]="stateEnum"-->
    </div>

    <!--    <div class="row mb-4" *ngIf="supplierService.method === 'NEW' || (supplierService.method === 'EDIT' && !showPassDiv)">-->
    <!--        <div class="col-12 align-items-end">-->
    <!--            <button class="btn btn-danger btn-lg" (click)="hideEdit()">-->
    <!--                <i class="oc-arrow-left"></i>-->
    <!--            </button>-->
    <!--        </div>-->
    <!--    </div>-->

    <div
        class="layout-grid"
        data-testid="t-detail-div-1752672977568-24"
    >
        <div
            class="row"
            data-testid="t-detail-div-1762851932780-1"
        >
            <div
                class="scrolling--col"
                [ngClass]="supplierService.method == 'NEW' || (supplierService.method == 'EDIT' && !showPassDiv) ? '' : 'col-lg-6'"
                data-testid="t-detail-div-1752672977568-22"
            >
                @if (supplierService.method == 'EDIT' && showPassDiv) {
                    <div
                        class="supplier-select--wrapper mb-3"
                        data-testid="t-detail-div-1752672977568-3"
                    >
                        <div
                            class="table-responsive table-oc-responsive table-datetime table-scrollable"
                            data-testid="t-detail-div-1752672977568-2"
                        >
                            <!--                    [dataSource]="supplierService.supplierContractDetail"-->
                            <table
                                cdk-table
                                [dataSource]="supplierService.supplierContracts"
                                id="contractTable"
                                class="table"
                                data-testid="t-detail-table-1752672977568-1"
                            >
                                <ng-container cdkColumnDef="costcenter">
                                    <th
                                        cdk-header-cell
                                        *cdkHeaderCellDef
                                        data-testid="t-detail-th-1752672977568-1"
                                    >
                                        {{ 'mws.contractcostcenter' | i18n }}
                                    </th>
                                    <td
                                        cdk-cell
                                        *cdkCellDef="let element"
                                        data-testid="t-detail-td-1752672977568-1"
                                    >
                                        {{ element._costcenterDescription }} ({{ element._costcenterNumber }})
                                    </td>
                                </ng-container>
                                <ng-container cdkColumnDef="contractNumber">
                                    <th
                                        cdk-header-cell
                                        *cdkHeaderCellDef
                                        data-testid="t-detail-th-1752672977568-2"
                                    >
                                        {{ 'mws.contractnumber' | i18n }}
                                    </th>
                                    <td
                                        cdk-cell
                                        *cdkCellDef="let element"
                                        data-testid="t-detail-td-1752672977568-2"
                                    >
                                        {{ element.id }}
                                    </td>
                                </ng-container>
                                <ng-container cdkColumnDef="dateFrom">
                                    <th
                                        style="width: 1%"
                                        cdk-header-cell
                                        *cdkHeaderCellDef
                                        data-testid="t-detail-th-1752672977568-3"
                                    >
                                        {{ 'mws.datefrom' | i18n }}
                                    </th>
                                    <td
                                        cdk-cell
                                        *cdkCellDef="let elementRef"
                                        data-testid="t-detail-td-1752672977568-3"
                                    >
                                        {{ elementRef.validFrom | ocDatepipe: 'L' }}
                                    </td>
                                </ng-container>
                                <ng-container cdkColumnDef="dateTill">
                                    <th
                                        style="width: 1%"
                                        cdk-header-cell
                                        *cdkHeaderCellDef
                                        data-testid="t-detail-th-1752672977568-4"
                                    >
                                        {{ 'mws.datetill' | i18n }}
                                    </th>
                                    <td
                                        cdk-cell
                                        *cdkCellDef="let elementRef"
                                        data-testid="t-detail-td-1752672977568-4"
                                    >
                                        {{ elementRef.validTill | ocDatepipe: 'L' }}
                                    </td>
                                </ng-container>
                                <tr
                                    cdk-header-row
                                    *cdkHeaderRowDef="displayedContractColumns"
                                    data-testid="t-detail-tr-1752672977568-1"
                                ></tr>
                                <tr
                                    cdk-row
                                    *cdkRowDef="let element; columns: displayedContractColumns"
                                    class="table-oc-row is-clickable"
                                    (click)="selectContract(element)"
                                    [ngClass]="{ selected: supplierService.supplierContract?.id === element.id }"
                                    data-testid="t-detail-tr-1752672977568-2"
                                ></tr>
                            </table>
                        </div>
                    </div>
                }

                <!--            <div class="supplier-select&#45;&#45;wrapper mb-3"-->
                <!--                 *ngIf="supplierService.method == 'EDIT' && showPassDiv">-->
                <!--                <div class="table-responsive table-oc-responsive">-->
                <!--                    <table cdk-table-->
                <!--                           [dataSource]="supplierContractCostcenterCustomers"-->
                <!--                           id="customerTable"-->
                <!--                           class="table">-->
                <!--                        <ng-container cdkColumnDef="costcenter">-->
                <!--                            <th cdk-header-cell *cdkHeaderCellDef>{{'mws.assignedcostcenter' | i18n}}</th>-->
                <!--                            <td cdk-cell *cdkCellDef="let element">-->
                <!--                                {{element['_supplierContractCostcenterNumber']}} - {{element['_supplierContractCostcenterDescription']}}-->
                <!--                            </td>-->
                <!--                        </ng-container>-->
                <!--                        <ng-container cdkColumnDef="customerName">-->
                <!--                            <th cdk-header-cell *cdkHeaderCellDef>{{'mws.customername' | i18n}}</th>-->
                <!--                            <td cdk-cell *cdkCellDef="let element">-->
                <!--                                {{element.supplierCustomer.customerName}}-->
                <!--                            </td>-->
                <!--                        </ng-container>-->
                <!--&lt;!&ndash;                        <ng-container cdkColumnDef="isFavorite">&ndash;&gt;-->
                <!--&lt;!&ndash;                            <th cdk-header-cell *cdkHeaderCellDef></th>&ndash;&gt;-->
                <!--&lt;!&ndash;                            <td cdk-cell *cdkCellDef="let elementRef">&ndash;&gt;-->
                <!--&lt;!&ndash;                                <i class="inline-icon" *ngIf="elementRef.supplierCustomer.isFavorite === true" [ngbTooltip]="'mws.favorite' | i18n" class="oc-heart-filled"></i>&ndash;&gt;-->
                <!--&lt;!&ndash;                            </td>&ndash;&gt;-->
                <!--&lt;!&ndash;                        </ng-container>&ndash;&gt;-->

                <!--                        <tr cdk-header-row *cdkHeaderRowDef="displayedCustomerColumns"></tr>-->
                <!--                        <tr cdk-row *cdkRowDef="let element; columns: displayedCustomerColumns"-->
                <!--                            class="table-oc-row is-clickable" (click)="selectCustomer(element)"-->
                <!--                            [ngClass]="{'selected': supplierService.supplierCurrentCustomer?.id === element.id}"></tr>-->
                <!--                    </table>-->
                <!--                </div>-->
                <!--            </div>-->

                @if (supplierService.method == 'EDIT' && showPassDiv) {
                    <div
                        class="supplier-select--wrapper mb-3"
                        data-testid="t-detail-div-1752672977568-5"
                    >
                        <div
                            class="table-responsive table-oc-responsive table-scrollable table-hover"
                            data-testid="t-detail-div-1752672977568-4"
                        >
                            <table
                                cdk-table
                                [dataSource]="myCostcenterCustomerList"
                                id="customerTable_2"
                                class="table"
                                data-testid="t-detail-table-1752672977568-2"
                            >
                                <ng-container cdkColumnDef="costcenterNumber">
                                    <th
                                        cdk-header-cell
                                        *cdkHeaderCellDef
                                        data-testid="t-detail-th-1752672977568-5"
                                    >
                                        {{ 'mws.assignedcostcenter' | i18n }}
                                    </th>
                                    <td
                                        cdk-cell
                                        *cdkCellDef="let element"
                                        data-testid="t-detail-td-1752672977568-5"
                                    >
                                        {{ element['costcenterNumber'] }} - {{ element['costcenterDescription'] }}
                                    </td>
                                </ng-container>
                                <ng-container cdkColumnDef="customerName">
                                    <th
                                        cdk-header-cell
                                        *cdkHeaderCellDef
                                        data-testid="t-detail-th-1752672977568-6"
                                    >
                                        {{ 'mws.customername' | i18n }}
                                    </th>
                                    <td
                                        cdk-cell
                                        *cdkCellDef="let element"
                                        data-testid="t-detail-td-1752672977568-6"
                                    >
                                        {{ element['customerName'] }}
                                    </td>
                                </ng-container>
                                <!--                        <ng-container cdkColumnDef="isFavorite">-->
                                <!--                            <th cdk-header-cell *cdkHeaderCellDef></th>-->
                                <!--                            <td cdk-cell *cdkCellDef="let elementRef">-->
                                <!--                                <i class="inline-icon" *ngIf="elementRef.supplierCustomer.isFavorite === true" [ngbTooltip]="'mws.favorite' | i18n" class="oc-heart-filled"></i>-->
                                <!--                            </td>-->
                                <!--                        </ng-container>-->
                                <ng-container cdkColumnDef="supplierContractCostcenterStatus">
                                    <th
                                        cdk-header-cell
                                        *cdkHeaderCellDef
                                        data-testid="t-detail-th-1752672977568-7"
                                    >
                                        {{ 'mws.status' | i18n }}
                                    </th>
                                    <td
                                        cdk-cell
                                        *cdkCellDef="let element"
                                        data-testid="t-detail-td-1752672977568-7"
                                    >
                                        @if (
                                            element['supplierContractCostcenterStatus'] &&
                                            element['supplierContractCostcenterStatus'].status &&
                                            element['supplierContractCostcenterStatus'].status.isUncomplete
                                        ) {
                                            <span
                                                class="badge badge bg-danger"
                                                data-testid="t-detail-span-1752672977568-1"
                                                >{{ 'mws.uncomplete' | i18n }}</span
                                            >
                                        }
                                        @if (
                                            element['supplierContractCostcenterStatus'] &&
                                            element['supplierContractCostcenterStatus'].status &&
                                            element['supplierContractCostcenterStatus'].status.isComplete
                                        ) {
                                            <span
                                                class="badge badge bg-secondary"
                                                data-testid="t-detail-span-1752672977568-2"
                                                >{{ 'mws.complete' | i18n }}</span
                                            >
                                        }
                                        @if (
                                            element['supplierContractCostcenterStatus'] &&
                                            element['supplierContractCostcenterStatus'].status &&
                                            element['supplierContractCostcenterStatus'].status.isArchived
                                        ) {
                                            <span
                                                class="badge bg-gray"
                                                data-testid="t-detail-span-1752672977568-3"
                                                >{{ 'mws.archived' | i18n }}</span
                                            >
                                        }
                                        @if (
                                            element['supplierContractCostcenterStatus'] &&
                                            element['supplierContractCostcenterStatus'].status &&
                                            element['supplierContractCostcenterStatus'].status.isEnabled
                                        ) {
                                            <span
                                                class="badge badge bg-success"
                                                data-testid="t-detail-span-1752672977568-4"
                                                >{{ 'mws.enabled' | i18n }}</span
                                            >
                                        }
                                    </td>
                                </ng-container>
                                <tr
                                    cdk-header-row
                                    *cdkHeaderRowDef="myDisplayedCostcenterCustomerListColumns"
                                    data-testid="t-detail-tr-1752672977568-3"
                                ></tr>
                                <tr
                                    cdk-row
                                    *cdkRowDef="let element; columns: myDisplayedCostcenterCustomerListColumns"
                                    class="table-oc-row is-clickable"
                                    (click)="selectCustomer(element['supplierContractCostcenterCustomer'])"
                                    [ngClass]="{
                                        selected:
                                            isCustomerSelected &&
                                            element['costcenterNumber'] + '_' + actualSupplierContractCostcenterCustomer?.supplierCustomer.id ===
                                                element['costcenterNumber'] + '_' + element['customerId'],
                                    }"
                                    data-testid="t-detail-tr-1752672977568-4"
                                ></tr>
                            </table>
                        </div>
                    </div>
                }

                @if (supplierService.method == 'NEW' || (supplierService.method == 'EDIT' && !showPassDiv)) {
                    <div
                        class="supplier-edit--wrapper"
                        data-testid="t-detail-div-1752672977568-21"
                    >
                        <div
                            ngbAccordion
                            [closeOthers]="true"
                            class="ngb-accordion-with-icon"
                            data-testid="t-detail-div-1752672977568-20"
                        >
                            <div
                                ngbAccordionItem
                                [disabled]="!coreService.checkAbility('execute', 'supplier.basedata')"
                                data-testid="t-detail-div-1752672977568-10"
                            >
                                <div
                                    ngbAccordionHeader
                                    data-testid="t-detail-div-1752672977568-7"
                                >
                                    <button
                                        ngbAccordionButton
                                        data-testid="t-detail-button-1752672977568-1"
                                    >
                                        <span
                                            class="card-header-text"
                                            data-testid="t-detail-span-1752672977568-5"
                                            >1. {{ 'mws.basedata' | i18n }}</span
                                        >
                                        @if (supplierService.supplierBasedata.currencyId && supplierService.supplierBasedata.mainAddress) {
                                            <div
                                                style="right: 50px; position: absolute"
                                                data-testid="t-detail-div-1752672977568-6"
                                            >
                                                <!--                                class="oc-general-check text-tiny text-success"-->
                                                <i
                                                    [ngClass]="
                                                        isBasedataValid()
                                                            ? 'oc-general-check text-tiny text-success'
                                                            : 'oc-general-cancel text-tiny text-danger'
                                                    "
                                                    data-testid="t-detail-i-1752672977568-1"
                                                ></i>
                                            </div>
                                        }
                                    </button>
                                </div>
                                <div
                                    ngbAccordionCollapse
                                    data-testid="t-detail-div-1752672977568-9"
                                >
                                    <div
                                        ngbAccordionBody
                                        data-testid="t-detail-div-1752672977568-8"
                                    >
                                        <ng-template>
                                            <app-basedata data-testid="t-detail-app-basedata-1752672977568-1" />
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                            <!-- VERTRAG -->
                            <!-- VERTRAG -->
                            <!-- VERTRAG -->
                            <div
                                ngbAccordionItem
                                data-testid="t-detail-div-1752672977568-15"
                            >
                                <div
                                    ngbAccordionHeader
                                    data-testid="t-detail-div-1752672977568-12"
                                >
                                    <button
                                        ngbAccordionButton
                                        data-testid="t-detail-button-1752672977568-2"
                                    >
                                        <span
                                            class="card-header-text"
                                            data-testid="t-detail-span-1752672977568-6"
                                            >2. {{ 'mws.conditions' | i18n }}</span
                                        >
                                        @if (isContractStatusValid) {
                                            <div
                                                style="right: 50px; position: absolute"
                                                data-testid="t-detail-div-1752672977568-11"
                                            >
                                                <i
                                                    class="oc-general-check text-tiny text-success"
                                                    data-testid="t-detail-i-1752672977568-2"
                                                ></i>
                                            </div>
                                        }
                                    </button>
                                </div>
                                <div
                                    ngbAccordionCollapse
                                    data-testid="t-detail-div-1752672977568-14"
                                >
                                    <div
                                        ngbAccordionBody
                                        data-testid="t-detail-div-1752672977568-13"
                                    >
                                        <ng-template>
                                            <app-contractdata data-testid="t-detail-app-contractdata-1752672977568-1" />
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                            <div
                                ngbAccordionItem
                                data-testid="t-detail-div-1752672977568-19"
                            >
                                <div
                                    ngbAccordionHeader
                                    data-testid="t-detail-div-1752672977568-16"
                                >
                                    <button
                                        ngbAccordionButton
                                        data-testid="t-detail-button-1752672977568-3"
                                    >
                                        <span
                                            class="card-header-text"
                                            data-testid="t-detail-span-1752672977568-7"
                                            >3. {{ 'mws.certifications' | i18n }}</span
                                        >
                                    </button>
                                </div>
                                <div
                                    ngbAccordionCollapse
                                    data-testid="t-detail-div-1752672977568-18"
                                >
                                    <div
                                        ngbAccordionBody
                                        data-testid="t-detail-div-1752672977568-17"
                                    >
                                        <ng-template>
                                            <app-certification data-testid="t-detail-app-certification-1752672977568-1" />
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                            <!-- BEWERTUNG -->
                            <!-- BEWERTUNG -->
                            <!-- BEWERTUNG -->
                            <!--
      <ngb-panel id="accordion-bewertung">
        <ng-template ngbPanelTitle>
          <span class="card-header-text">4. {{'mws.ratings' | i18n}}</span>
        </ng-template>
        <ng-template ngbPanelContent>
          <app-ratings></app-ratings>
        </ng-template>
      </ngb-panel>
      -->
                        </div>
                    </div>
                }
            </div>

            @if (isSupplierLoaded) {
                <div
                    [ngClass]="supplierService.method == 'NEW' || (supplierService.method == 'EDIT' && !showPassDiv) ? '' : 'scrolling--col col-12  col-lg-6'"
                    data-testid="t-detail-div-1752672977568-23"
                >
                    <app-offcanvas
                        (hideOffcanvas)="hidePass()"
                        [showCloseOffcanvasDiv]="false"
                        [offcanvasFadein]="supplierService.method == 'NEW' || (supplierService.method == 'EDIT' && !showPassDiv) ? true : false"
                        data-testid="t-detail-app-offcanvas-1752672977568-1"
                    >
                        <app-card
                            [supplierContacts]="supplierContacts"
                            [supplierContractCostcenterStatus]="supplierContractCostcenterStatus"
                            [actualCostcenterInfo]="actualCostcenterInfo"
                            [actualSupplierContractCostcenterCustomer]="actualSupplierContractCostcenterCustomer"
                            data-testid="t-detail-app-card-1752672977568-1"
                        ></app-card>
                    </app-offcanvas>
                </div>
            }
        </div>
    </div>

    <!-- -->
    <ng-template
        #createStepsModal
        let-c="close"
        let-d="dismiss"
    >
        <form
            [formGroup]="basedataForm"
            class="customer-form"
            novalidate
            data-testid="t-detail-form-1752672977568-1"
        >
            <div
                class="modal-header"
                data-testid="t-detail-div-1752672977568-25"
            >
                <button
                    type="button"
                    id="newsupplier-cancel"
                    [attr.aria-label]="'button.discard' | i18n"
                    class="btn btn-close"
                    (click)="closeSupplerCreateModal()"
                    data-testid="t-detail-button-1752672977568-4"
                >
                    <i
                        class="oc-general-cancel"
                        data-testid="t-detail-i-1752672977568-3"
                    ></i>
                </button>
                <span
                    class="h5 modal-title"
                    data-testid="t-detail-span-1752672977568-8"
                    >{{ 'mws.modal.title.createnewsupplier' | i18n }}</span
                >
            </div>

            <div
                class="modal-body"
                data-testid="t-detail-div-1752672977568-33"
            >
                <div
                    class="step-bar"
                    data-testid="t-detail-div-1752672977568-26"
                >
                    <ul data-testid="t-detail-ul-1752672977568-1">
                        <li
                            class="progress-step"
                            [ngClass]="step === 1 ? (actionNewCostcenterId ? 'done' : 'active') : ''"
                            data-testid="t-detail-li-1752672977568-1"
                        >
                            @if (!actionNewCostcenterId) {
                                <span data-testid="t-detail-span-1752672977568-9">1.</span>
                            }
                            @if (actionNewCostcenterId) {
                                <span data-testid="t-detail-span-1752672977568-10"
                                    ><i
                                        class="oc-general-check"
                                        data-testid="t-detail-i-1752672977568-4"
                                    ></i
                                ></span>
                            }
                        </li>

                        <li
                            class="progress-step"
                            [ngClass]="step === 2 ? (basedataForm.get('name').value && basedataForm.get('name').value.length > 0 ? 'done' : 'active') : ''"
                            data-testid="t-detail-li-1752672977568-2"
                        >
                            @if (!basedataForm.get('name').value || basedataForm.get('name').value.length === 0) {
                                <span data-testid="t-detail-span-1752672977568-11">2.</span>
                            }
                            @if (basedataForm.get('name').value && basedataForm.get('name').value.length > 0) {
                                <span data-testid="t-detail-span-1752672977568-12"
                                    ><i
                                        class="oc-general-check"
                                        data-testid="t-detail-i-1752672977568-5"
                                    ></i
                                ></span>
                            }
                        </li>
                    </ul>
                </div>

                @if (step === 1) {
                    <div
                        id="step-1"
                        data-testid="t-detail-div-1752672977568-29"
                    >
                        <div
                            class="add--header"
                            data-testid="t-detail-div-1752672977568-28"
                        >
                            <div
                                class="col"
                                data-testid="t-detail-div-1752672977568-27"
                            >
                                <span
                                    class="h5"
                                    data-testid="t-detail-span-1752672977568-13"
                                >
                                    {{ 'mws.prompt.step' | i18n: 'notr:' + 1 }}
                                    {{ 'mws.usermanagement.button.choosecostcenter' | i18n }}
                                </span>
                            </div>
                        </div>
                        <app-costcenterbasic
                            #costCenterModalBasic
                            [useTriState]="false"
                            [multipleSelect]="false"
                            [expandAll]="true"
                            [checkIfProductionUnit]="false"
                            [nodes]="costcentertreeService.costcenterTreeNodes"
                            (onClickCostcenterSelect)="selectCostcenter($event)"
                            data-testid="t-detail-app-costcenterbasic-1752672977568-1"
                        ></app-costcenterbasic>
                    </div>
                }
                @if (step === 2) {
                    <div
                        id="step-2"
                        data-testid="t-detail-div-1752672977568-32"
                    >
                        <div
                            class="add--header"
                            data-testid="t-detail-div-1752672977568-31"
                        >
                            <div
                                class="col"
                                data-testid="t-detail-div-1752672977568-30"
                            >
                                <span
                                    class="h5"
                                    data-testid="t-detail-span-1752672977568-14"
                                >
                                    {{ 'mws.prompt.step' | i18n: 'notr:' + 2 }}
                                    {{ 'mws.modal.prompt.createnewsupplier' | i18n }}
                                </span>
                            </div>
                        </div>
                        <input
                            type="text"
                            #name
                            id="name"
                            formControlName="name"
                            autofocus
                            class="form-control"
                            placeholder="{{ 'mws.suppliername' | i18n }}"
                            data-testid="t-detail-input-1752672977568-1"
                        />
                        <oc-validator-error
                            [control]="basedataForm.controls.name"
                            [inputElementId]="'name'"
                            [propertyName]="'name'"
                            data-testid="t-detail-oc-validator-error-1752672977568-1"
                        ></oc-validator-error>
                    </div>
                }
            </div>

            <div
                class="modal-footer"
                data-testid="t-detail-div-1752672977568-35"
            >
                <div
                    class="button-wrapper"
                    data-testid="t-detail-div-1752672977568-34"
                >
                    <button
                        type="button"
                        [attr.aria-label]="'previously' | i18n"
                        class="btn btn-primary"
                        [disabled]="step === 1"
                        (click)="previousStep()"
                        data-testid="t-detail-button-1752672977568-5"
                    >
                        <i
                            class="oc-arrow-left"
                            data-testid="t-detail-i-1752672977568-6"
                        ></i>
                    </button>

                    <button
                        type="button"
                        attr.aria-label="{{ 'button.next' | i18n }}"
                        class="btn btn-primary"
                        [disabled]="!actionNewCostcenterId || step === 2"
                        (click)="nextStep()"
                        data-testid="t-detail-button-1752672977568-6"
                    >
                        <i
                            class="oc-arrow-right"
                            data-testid="t-detail-i-1752672977568-7"
                        ></i>
                    </button>

                    <button
                        type="button"
                        id="newsupplier-success"
                        attr.aria-label="{{ 'button.check' | i18n }}"
                        class="btn btn-success ms-auto"
                        [disabled]="!basedataForm.get('changed').touched"
                        (click)="submitSupplier()"
                        data-testid="t-detail-button-1752672977568-7"
                    >
                        <i
                            class="oc-general-check"
                            data-testid="t-detail-i-1752672977568-8"
                        ></i>
                    </button>
                </div>
            </div>
        </form>
    </ng-template>
</div>
